<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>发布任务</el-breadcrumb-item>
      <el-breadcrumb-item>任务列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card v-loading="wholeloading">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-input
            placeholder="请输入内容"
            clearable
            v-model="queryInfo.query"
            @clear="handleCurrentChange(1);"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="
                handleCurrentChange(1);
              "
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-upload
            class="upload-demo"
            action="#"
            :http-request="uploadData"
            :show-file-list="false"
            :before-upload="checkUploadZip"
          >
            <el-tooltip
              class="item"
              effect="dark"
              content="将所有dcm放至一个zip压缩包上传"
              placement="top-start"
            >
              <el-button size="medium" type="primary">点击上传</el-button>
            </el-tooltip>
          </el-upload>
        </el-col>
      </el-row>

      <el-table :data="datalist" stripe border style="width: 100%" v-loading="loading">
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="data_id" label="数据编号" width="80"></el-table-column>
        <el-table-column prop="data_name" label="数据名称" min-width="150"></el-table-column>
        <el-table-column prop="age" label="年龄" width="70"></el-table-column>
        <el-table-column label="上传时间" width="140">
          <template v-slot="scope">{{ scope.row.upload_time }}</template>
        </el-table-column>
        <el-table-column label="数据裁剪" width="80">
          <template v-slot="scope">
            <el-button size="mini" type="primary" @click="gotoBox(scope.row.data_id)">裁剪</el-button>
          </template>
        </el-table-column>
        <el-table-column label="AI建模" width="80">
          <template v-slot="scope">
            <el-button size="mini" type="primary" @click="startAi(scope.row)">运行</el-button>
          </template>
        </el-table-column>
        <el-table-column label="AI模型下载" width="100">
          <template v-slot="scope">
            <span v-if="scope.row.ai_status === '0'">未运行</span>
            <span v-if="scope.row.ai_status === '1'">正在计算</span>
            <span v-if="scope.row.ai_status === '2'">
              <el-button
                size="mini"
                type="primary"
                @click="setRightDialogVisible = true;downDiag.dataid=scope.row.data_id;downDiag.type='0'"
              >
                <i class="el-icon-download" style="font-size:12px;"></i>
              </el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="AI完成时间" width="140">
          <template v-slot="scope">
            <span v-if="scope.row.ai_finish_time === null">未完成</span>
            <span v-if="scope.row.ai_finish_time !== null">{{ scope.row.ai_finish_time }}</span>
          </template>
        </el-table-column>
        <el-table-column label="AI预览" width="70">
          <template v-slot="scope">
            <span v-if="scope.row.ai_finish_time !== null">
              <a :href="'/STLViewer/model.html?dataid='+scope.row.data_id+'&type=0'" target="_blank">预览</a>
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="process_user" label="处理人">
          <template v-slot="scope">
            <span v-if="scope.row.process_user === null">无</span>
            <span v-if="scope.row.process_user !== null">{{scope.row.process_user}}</span>
          </template>
        </el-table-column>
        <el-table-column label="模型下载" width="80">
          <template v-slot="scope">
            <span v-if="scope.row.finish_time === null">无</span>
            <span v-if="scope.row.finish_time !== null">
              <el-button
                size="mini"
                type="primary"
                @click="setRightDialogVisible = true;downDiag.dataid=scope.row.data_id;downDiag.type='1'"
              >
                <i class="el-icon-download" style="font-size:12px;"></i>
              </el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="完成时间" width="140">
          <template v-slot="scope">
            <span v-if="scope.row.finish_time === null">无</span>
            <span v-if="scope.row.finish_time !== null">{{ scope.row.finish_time }}</span>
          </template>
        </el-table-column>
        <el-table-column label="预览" width="70">
          <template v-slot="scope">
            <span v-if="scope.row.finish_time !== null">
              <a :href="'/STLViewer/model.html?dataid='+scope.row.data_id+'&type=1'" target="_blank">预览</a>
            </span>
          </template>
        </el-table-column> -->
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 15, 20]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      ></el-pagination>
    </el-card>

    <!-- 选择下载STL模型对话框 -->
    <el-dialog
      title="选择STL模型"
      :visible.sync="setRightDialogVisible"
      @close="setRightDialogClosed"
      width="30%"
    >
      <el-checkbox
        :indeterminate="downDiag.isIndeterminate"
        v-model="downDiag.checkAll"
        @change="handleCheckAllChange"
      >全选</el-checkbox>
      <div style="margin: 15px 0;"></div>
      <el-checkbox-group v-model="downDiag.checkedOptions" @change="handleCheckedOptionsChange">
        <el-checkbox
          class="cardiacCheckbox"
          v-for="option in downDiag.options"
          :label="option"
          :key="option"
        >{{option}}</el-checkbox>
      </el-checkbox-group>
      <div slot="footer">
        <el-button @click="setRightDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="downloadSTLs">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="上传" :visible.sync="uploadDialogVisible" width="25%" @close="interuptUpload">
      <div style="text-align:center;">
        <el-progress
          type="circle"
          :percentage="uploadDiag.progressPercent"
          style="margin-left:20px;"
        ></el-progress>
        <h5>{{uploadDiag.text}}</h5>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const downloadOptions = [
  "肺动脉",
  "左心房肺静脉",
  "上腔静脉",
  "主动脉",
  "右心房",
  "右心室",
  "左心室",
  "心包",
];
export default {
  data() {
    return {
      wholeloading: false,
      loading: false,
      uploadDialogVisible: false,
      queryInfo: {
        query: "",
        pagenum: 1,
        pagesize: 10,
      },
      datalist: [],
      total: 0,
      setRightDialogVisible: false,
      downDiag: {
        type: null,
        dataid: null,
        checkAll: false,
        checkedOptions: [],
        options: downloadOptions,
        isIndeterminate: false,
      },
      uploadDiag: {
        progressPercent: 0,
        text: "正在上传",
      },
      source: null,
      timer:null
    };
  },
  methods: {
    async getDataList() {
      clearInterval(this.timer);
      this.loading = true;
      const { data } = await this.$http.post("data/publishlist", {
        queryinfo: this.queryInfo,
      });
      if (data.status === 100) {
        this.datalist = data.data.list;
        this.total = data.data.total;
        this.loading = false;
        if (this.containsAIundone()){
          this.timer = setInterval(this.getDataList2,20000);
        }
      }
    },
    async getDataList2() {
      const { data } = await this.$http.post("data/publishlist", {
        queryinfo: this.queryInfo,
      });
      if (data.status === 100) {
        this.datalist = data.data.list;
        this.total = data.data.total;
        if (!this.containsAIundone()){
          clearInterval(this.timer);
        }
      }
    },
    containsAIundone(){
      for (var i =0;i<this.datalist.length;i++){
        if (this.datalist[i].ai_status==="1") return true;
      }
      return false;
    },
    checkUploadZip(file) {
      if (file.name.endsWith(".zip") === false) {
        this.$message({
          message: "请上传zip格式压缩包",
          type: "error",
        });
        return false;
      }
      if (file.size > 200 * 1024 * 1024) {
        this.$message({
          message: "文件大小不超过200m",
          type: "error",
        });
        return false;
      }
    },
    async uploadData(params) {
      let formdata = new FormData();
      formdata.append("zipfile", params.file);
      this.$message({
        message: "文件正在上传，请等待！",
        type: "warning",
      });
      this.source = this.$http.CancelToken.source();
      const config = {
        "Content-Type": "multipart/form-data",
        cancelToken: this.source.token,
        onUploadProgress: (progressEvent) => {
          this.uploadDiag.progressPercent = Number(
            ((progressEvent.loaded / progressEvent.total) * 100).toFixed(2)
          );
          if (this.uploadDiag.progressPercent === 100)
            this.uploadDiag.text = "正在解析";
        },
      };
      this.uploadDialogVisible = true;
      this.uploadDiag.progressPercent = 0;
      this.uploadDiag.text = "正在上传";
      const { data } = await this.$http.post(
        "data/uploaddicom",
        formdata,
        config
      );
      this.uploadDialogVisible = false;
      if (data.status === 100) {
        this.$message({
          message: "上传成功",
          type: "success",
        });
        this.getDataList();
      }
    },
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize;
      this.queryInfo.pagenum = 1;
      this.getDataList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage;
      this.getDataList();
    },
    setRightDialogClosed() {
      this.downDiag.checkedOptions = [];
      this.downDiag.checkAll = false;
      this.downDiag.isIndeterminate = false;
      this.downDiag.dataid = null;
    },
    downloadSTLs() {
      var checks = this.downDiag.checkedOptions;
      if (checks.length === 0) {
        this.$message({
          message: "未勾选",
          type: "error",
        });
        return;
      }
      var seq = this.downDiag.options;
      var str = "";
      for (var i = 0; i < seq.length; i++) {
        if (checks.indexOf(seq[i]) !== -1) str = str + "1";
        else str = str + "0";
      }
      this.$message({
        message: "正在生成压缩包",
        type: "success",
      });
      let baseurl = this.$http.defaults.baseURL;
      if (this.downDiag.type === "0") {
        window.location =
          baseurl + "/data/aistl/" + this.downDiag.dataid + "/" + str;
      } else if (this.downDiag.type === "1") {
        window.location =
          baseurl + "/data/downloadSTL/" + this.downDiag.dataid + "/" + str;
      }
      this.setRightDialogVisible = false;
    },
    handleCheckAllChange(val) {
      this.downDiag.checkedOptions = val ? this.downDiag.options : [];
      this.downDiag.isIndeterminate = false;
    },
    handleCheckedOptionsChange(value) {
      let checkedCount = value.length;
      this.downDiag.checkAll = checkedCount === this.downDiag.options.length;
      this.downDiag.isIndeterminate =
        checkedCount > 0 && checkedCount < this.downDiag.options.length;
    },
    gotoBox(dataid) {
      this.$router.push("/box?id=" + dataid);
    },
    interuptUpload() {
      if (this.uploadDiag.progressPercent < 100) {
        this.source.cancel();
      }
    },
    startAi(rowdata) {
      if (rowdata.ai_status === "1") {
        this.$message({ message: "正在计算，请稍后", type: "warning" });
        return;
      }
      if (rowdata.box === null || rowdata.box === "") {
        this.$message({ message: "请先裁剪", type: "error" });
        return;
      }
      this.$confirm("确定使用AI进行建模", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async () => {
          this.loading = true;
          const { data } = await this.$http.get("data/ai/" + rowdata.data_id);
          this.loading = false;
          if (data.status === 100) {
            this.$message({ type: "success", message: "已提交" });
            this.getDataList();
          }
        })
        .catch(() => {
          this.$message({ type: "info", message: "已取消" });
        });
    },
  },
  created() {
    this.getDataList();
  },
  beforeDestroy() {
    console.log("before destory")
    clearInterval(this.timer);
  }
};
</script>

<style lang="less" scoped>
.el-cascader {
  width: 100%;
}
.cardiacCheckbox {
  display: block;
  margin-left: 20px;
  margin-top: 10px;
}
</style>
